import React, {
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";

import { Layout, Card, Row, Col } from "antd";

import {
  UserOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  CalendarOutlined,
  LockOutlined,
  AppstoreOutlined,
  FilePdfOutlined,
  PictureOutlined,
  MobileOutlined,
} from "@ant-design/icons";

import axios from "axios";
import { useNavigate } from "react-router-dom";

import "./home.css";
import { URL } from "../config";
import { LoaderContext } from "../Components/dashboard";

const { Content } = Layout;

const DashboardHome = () => {
  const navigate = useNavigate();
  const { setLoading } = useContext(LoaderContext) || {};


  const [stats, setStats] = useState({
    users: 0,
    pending: 0,
    rejected: 0,
    expired: 0,
    nearExpiry: 0,
    deviceReq: 0,
    songs: 0,
    pdf: 0,
    banner: 0,
    images: 0,
  });


  const prevStatsRef = useRef(stats);


  const loadStats = async (firstTime = false) => {
    try {
     
      if (firstTime) setLoading && setLoading(true);

      const startTime = Date.now();

      const [
        userRes,
        resetPwdRes,
        deviceRes,
        pdfRes,
        bannerRes,
        imgRes,
      ] = await Promise.all([
        axios.get(`${URL}/user/count`),
        axios.get(`${URL}/forgetpasswords/count`),
        axios.get(`${URL}/devicechange/count`),
        axios.get(`${URL}/addpdf/count`),
        axios.get(`${URL}/addbanner/count`),
        axios.get(`${URL}/addimg/count`),
      ]);

    
      const newStats = {
        users: userRes.data?.data?.totalUsers || 0,
        pending: userRes.data?.data?.pendingUsers || 0,
        rejected: userRes.data?.data?.rejectedUsers || 0,
        expired: userRes.data?.data?.expiredUsers || 0,
        nearExpiry: userRes.data?.data?.nearExpiryUsers || 0,
        deviceReq: deviceRes.data?.count || 0,

        songs: resetPwdRes.data?.count || 0,
        pdf: pdfRes.data?.data?.activePdfs || 0,
        banner: bannerRes.data?.data?.activeBanners || 0,
        images: imgRes.data?.data?.activeImages || 0,
      };

   
      const prevStats = prevStatsRef.current;
      const changed =
        JSON.stringify(prevStats) !== JSON.stringify(newStats);

   
      if (changed) {
        setLoading && setLoading(true);


        const elapsed = Date.now() - startTime;
        const remaining = 1500 - elapsed;

        if (remaining > 0) {
          await new Promise((resolve) =>
            setTimeout(resolve, remaining)
          );
        }

   
        setStats(newStats);
        prevStatsRef.current = newStats;

        setLoading && setLoading(false);
      }

      if (firstTime) setLoading && setLoading(false);
    } catch (err) {
      console.error("Dashboard error:", err);
      setLoading && setLoading(false);
    }
  };


  useEffect(() => {
  
    loadStats(true);
    const interval = setInterval(() => {
      loadStats(false); 
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleCardClick = (title) => {
    switch (title) {
      case "Users":
        navigate("/dashboard/userregistration-list");
        break;
      case "Pending":
        navigate("/dashboard/pending");
        break;
      case "Rejected":
        navigate("/dashboard/rejected");
        break;
      case "Expired":
        navigate("/dashboard/expired");
        break;
      case "Near Expiry":
        navigate("/dashboard/expiringsoon");
        break;
      case "Device Requests":
        navigate("/dashboard/devicechange");
        break;
      case "Reset Password":
        navigate("/dashboard/forgetpassword");
        break;
      case "PDF":
        navigate("/dashboard/addpdflist");
        break;
      case "Banner":
        navigate("/dashboard/addbannerlist");
        break;
      case "Images":
        navigate("/dashboard/addimglist");
        break;
      default:
        break;
    }
  };

  const cards = [
    {
      title: "Users",
      count: stats.users,
      icon: <UserOutlined />,
      color: "grad-green",
    },
    {
      title: "Pending",
      count: stats.pending,
      icon: <ClockCircleOutlined />,
      color: "grad-orange",
    },
    {
      title: "Rejected",
      count: stats.rejected,
      icon: <CloseCircleOutlined />,
      color: "grad-red",
    },
    {
      title: "Expired",
      count: stats.expired,
      icon: <WarningOutlined />,
      color: "grad-darkpink",
    },
    {
      title: "Near Expiry",
      count: stats.nearExpiry,
      icon: <CalendarOutlined />,
      color: "grad-purple",
    },
    {
      title: "Device Requests",
      count: stats.deviceReq,
      icon: <MobileOutlined />,
      color: "grad-cyan",
    },
    {
      title: "Reset Password",
      count: stats.songs,
      icon: <LockOutlined />,
      color: "grad-blue",
    },
    // {
    //   title: "PDF",
    //   count: stats.pdf,
    //   icon: <FilePdfOutlined />,
    //   color: "grad-slate",
    // },
    // {
    //   title: "Banner",
    //   count: stats.banner,
    //   icon: <AppstoreOutlined />,
    //   color: "grad-indigo",
    // },
    // {
    //   title: "Images",
    //   count: stats.images,
    //   icon: <PictureOutlined />,
    //   color: "grad-teal",
    // },
  ];

  return (
    <Layout className="dashboard-layout">
      <Content className="dashboard-content">
        <Row gutter={[16, 16]} justify="center">
          {cards.map((item, index) => (
            <Col
              key={index}
              xs={12}
              sm={12}
              md={8}
              lg={6}
              xl={6}
            >
              <Card
                hoverable
                className={`stat-card ${item.color}`}
                onClick={() => handleCardClick(item.title)}
              >
                <div className="stat-inner">
                  <div className="stat-icon">{item.icon}</div>

                  <div className="stat-info">
                    <p>{item.title}</p>
                    <h2>{item.count}</h2>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Content>
    </Layout>
  );
};

export default DashboardHome;
